export default __webpack_public_path__ + "static/microphone_w.3791ff0d1625d6725765aca23adac1d3.png";